// Components==============
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './Stats.module.scss';
// =========================

const parent = {
  visible: {
    transition: { staggerChildren: 0.15, delayChildren: 0.5 },
  },
  invisible: {},
};

const child = {
  visible: { opacity: 1 },
  invisible: { opacity: 0 },
};

export default function Stats() {
  const translate = useTranslate();

  const sparks = useRedux(
    (state) =>
      state.reflection?.entities.allIds
        .map((id) => {
          const reflection = state.reflection?.entities.byId[id];

          if (reflection?.created_by === state.authentication?.user?.id)
            return reflection?.sparks;

          return undefined;
        })
        .flat()
        .filter((exists) => exists)
    // // filter duplicates
    // .filter((v, i, a) => a.findIndex((t) => t?.id === v?.id) === i)
  )?.length;

  const dreams = useRedux((state) =>
    state.dream?.entities.allIds
      .map((id) => state.dream?.entities.byId[id])
      .filter((dream) => dream?.finished)
  )?.length;

  const activities = useRedux((state) =>
    state.process?.entities.allIds
      .map((id) => state.process?.entities.byId[id])
      .filter((p) => p?.finished)
  )?.length;

  return (
    <div styleName="box">
      <motion.div
        styleName="wrapper"
        initial="invisible"
        animate="visible"
        variants={parent}
      >
        <motion.div styleName="activities" variants={child}>
          <h3 style={{ fontSize: (activities || 0) >= 1000 ? 24 : '' }}>
            {activities}
          </h3>
          <span>
            {(activities && activities > 1) || activities === 0
              ? translate('project.terms.activities')
              : translate('project.terms.activity')}
          </span>
        </motion.div>
        <motion.div styleName="sparks" variants={child}>
          <h3>{sparks}</h3>
          <span>Spark{(sparks && sparks > 1) || sparks === 0 ? 's' : ''}</span>
        </motion.div>
        <motion.div styleName="dreams" variants={child}>
          <h3>{dreams}</h3>
          <span>
            {translate(
              (dreams && dreams > 1) || dreams === 0
                ? 'dream.terms.dreams'
                : 'dream.terms.dream'
            )}
          </span>
        </motion.div>
        <motion.div styleName="check" variants={child}>
          <FontAwesomeIcon icon={faCheckCircle} />
        </motion.div>
        <p>{translate('general.terms.stats')}</p>
      </motion.div>
    </div>
  );
}
